import { useQueryClient } from '@tanstack/react-query';
import { createContext, PropsWithChildren, useContext } from 'react';
import { initialiseClients } from 'stores/client-store';
import { initialiseApiClient } from 'utils/api/initialise-api-client';
import { Configuration } from '../../src/bff/client';
import { ApiClient } from './ApiClient';

const ApiClientContext = createContext<ApiClient | undefined>(undefined);

interface ApiClientProviderProps {
  apiConfig: Configuration;
}

export const ApiClientProvider = ({
  apiConfig,
  children
}: PropsWithChildren<ApiClientProviderProps>) => {
  const queryClient = useQueryClient();
  const apiClient = initialiseApiClient(apiConfig);

  initialiseClients({ apiClient, queryClient });

  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
};

export const useApiClient = () => {
  const context = useContext(ApiClientContext);

  if (!context) {
    throw new Error(
      'Cannot use Api Client Context outside of its Provider. Please ensure you have add the ApiClientProvider at the top of your app'
    );
  }
  return context;
};
